module.exports = __webpack_public_path__ + "img/social-media-display-nissan.960f2163.png";